import Swal from 'sweetalert2';

// Roadies popups: tagged so roadies.css can give them the game font and a readable size
// (popups render in <body>, outside .rd-page, so they would otherwise get BURBANK_BIG at 1em).
export default Swal.mixin({
  customClass: {
    popup: 'rd-swal',
    title: 'rd-swal-title',
    htmlContainer: 'rd-swal-text',
    confirmButton: 'rd-swal-btn',
  },
});
